<template>
  <div class="businessRecommend">
   <!-- 商机推荐 -->
   <card-plate title="推荐商机">
     <span slot="headMore"><span class="card-tit-hint">推荐的项目不精准？前往</span><span @click="toPath(url)">维护标签</span></span>
     <ul slot="headCont" class="list" v-if="(pushSupplierInfo&&pushSupplierInfo[0]&&pushSupplierInfo[0].hasSupplierBuyCYGService!=0)||(pushSupplierInfo&&pushSupplierInfo.length==0)">
       <li :key="idx" v-for="(item,idx) in pushSupplierInfo||[]" @click="toPath(item.projectURL)"><div class="mr8"><img src="../../../assets/images/sj_icon.svg" alt=""></div><div>{{item.projectName}}</div></li>
       <!-- <li><span class="mr8"><img src="../../../assets/images/sj_icon.svg" alt=""></span><span>禅医健康城综合体项目人防工程招标CXCG2019...</span></li>
       <li><span class="mr8"><img src="../../../assets/images/sj_icon.svg" alt=""></span><span>禅医健康城综合体项目人防工程招标CXCG2019...</span></li>
       <li><span class="mr8"><img src="../../../assets/images/sj_icon.svg" alt=""></span><span>禅医健康城综合体项目人防工程招标CXCG2019...</span></li>
       <li><span class="mr8"><img src="../../../assets/images/sj_icon.svg" alt=""></span><span>禅医健康城综合体项目人防工程招标CXCG2019...</span></li>
       <li><span class="mr8"><img src="../../../assets/images/sj_icon.svg" alt=""></span><span>禅医健康城综合体项目人防工程招标CXCG2019...</span></li> -->
        <empty-tab v-if="(pushSupplierInfo&&pushSupplierInfo.length==0)||!pushSupplierInfo"></empty-tab>
       <div class="list-more" @click="toPath2('/supplier',{'bussiessType':2})">更多正在招标的项目>></div>
     </ul>
     <ul slot="headCont" class="list" v-else>
       <div class="empty-cont">该供应商没有购买<span @click="toPath(pushSupplierInfo[0].cygUrl)" class="businessRecommend-cyg-col">诚意供服务</span>,请点击购买</div>
       <div class="list-more" @click="toPath2('/supplier',{'bussiessType':2})">更多正在招标的项目>></div>
     </ul>
   </card-plate>
  </div>
</template>
<script>
import cardPlate from './cardPlate.vue'
import emptyTab from './emptyTab.vue'
export default {
  props: ['pushSupplierInfo','url'],
  components: {
    'card-plate': cardPlate,
    'empty-tab': emptyTab
  },
  data () {
    return {
    }
  },
  created () {
    
  },
  methods: {
    
    toPath (url) {
      window.open(url, '_blank')
    },
    
    toPath2(url,params={}){
      let routeData = this.$router.resolve({
        path: url,
        query:params
      });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>
<style>
.businessRecommend{
  background: #FFFFFF;
  border-radius: 5px;
  border-radius: 5px;
}
.businessRecommend .card-tit-hint{
  color: #909399;
  margin-right: 10px;
}
.businessRecommend .card-tit-hint:hover{
  cursor: text;
}
.businessRecommend .businessRecommend-cyg-col{
  color:#2E8AF1
}
.businessRecommend .businessRecommend-cyg-col:hover{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/businessRecommend.vue